import { useState, useEffect, useContext } from 'react'

import { PassContext } from "../../pass-context"
import captureAppleFrontPreview from '../capture-front-preview'

export default ({ show }) => {
  const { template, model, variables } = useContext(PassContext)

  const [minature, setMinature] = useState(null)

  useEffect(() => {
    captureAppleFrontPreview()
      .then(function (dataUrl) {
        setMinature(dataUrl)
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      })
  },[template, model, variables])

  if (show) {
    return (
      <div className="front-minature">
        <div className="minature">
          <img src={minature} />
        </div>
      </div>
    )
  }
}
